import React from "react";
import {css} from "emotion";
import {useRouteMatch} from "react-router-dom";
import {colors} from "../styles/theme";

const PaywallBadge = ({plan, style}) => {
  return (
    <div className={container + ` ${plan}`} style={style}>
      {plan}
    </div>
  )
};

export default PaywallBadge;

const container = css`
  background-color: black;
  padding: 3px 12px;
  text-transform: uppercase;
  border-radius: 50px;
  position: absolute;
  right: 15px;
  color: white;
  letter-spacing: 1px;
  font-weight: 500;
  font-size: 14px;
  transform: translateY(-50%);
  top: 50%;
  
  &.starter {
    background-color: ${colors.starterPlan};
  }
  
  &.premium {
    background-color: ${colors.premiumPlan};
  }
  
  &.pro {
    background-color: ${colors.proPlan};
  }
`;
